import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var colors = {
  crimson: '#CC0000',
  grass: '#007700',
  lilac: '#964dea',
  'neutral-1': '#F7F6F5',
  'neutral-2': '#E8E7E6',
  'neutral-3': '#D1D0CF',
  'neutral-4': '#949494',
  'neutral-5': '#76767C',
  'neutral-6': '#595963',
  ocean: '#1a9be0',
  'purple-bright': '#8046F1',
  'purple-dark': '#322744',
  'purple-mid': '#662DBE',
  'tone-blue-t1': '#3291AA',
  'tone-blue-t2': '#A5EBEB',
  'tone-blue-t3': '#D7F6F5',
  'tone-blue-t4': '#E6FAFA',
  'tone-blue': '#14325F',
  'tone-brown-t1': '#ED785A',
  'tone-brown-t2': '#FA967D',
  'tone-brown-t3': '#FFD2B9',
  'tone-brown-t4': '#FFE6DC',
  'tone-brown': '#D25537',
  'tone-green-t1': '#4BA073',
  'tone-green-t2': '#8CD7AA',
  'tone-green-t3': '#CDF0CD',
  'tone-green-t4': '#EBFAE6',
  'tone-green': '#0A5F41',
  'tone-maroon-t1': '#D25596',
  'tone-maroon-t2': '#FF91D7',
  'tone-maroon-t3': '#FAC8F0',
  'tone-maroon-t4': '#FAE1F5',
  'tone-maroon': '#911E55',
  'tone-orange-t1': '#FFAA00',
  'tone-orange-t2': '#FFC800',
  'tone-orange-t3': '#FFF0A0',
  'tone-orange-t4': '#FFF8C8',
  'tone-orange': '#F58C00',
  white: '#fff',
  'neutral-5-opacity50': 'rgba(118,118,124, 0.5)',
  'purple-bright-opacity40': 'rgba(128,70,241, 0.4)',
  'purple-dark-opacity40': 'rgba(50,39,68, 0.4)',
  'purple-dark-opacity60': 'rgba(50,39,68, 0.6)',
  'purple-dark-opacity80': 'rgba(50,39,68, 0.8)',
  'purple-mid-opacity10': 'rgba(102, 45, 190, 0.1)',
  black: '#000',
  'black-opacity30': 'rgba(0, 0, 0, 0.3)',
  'black-opacity10': 'rgba(0, 0, 0, 0.1)',
  'white-opacity80': 'rgba(255, 255, 255, 0.8)',
  'white-opacity50': 'rgba(255, 255, 255, 0.5)',
  'white-opacity30': 'rgba(255, 255, 255, 0.3)',
  'white-opacity10': 'rgba(255, 255, 255, 0.1)',
  'white-purple-mid-mix': 'rgb(240,234,248)',
  transparent: 'transparent'
};
var colorNameMapping = {
  'function-error': colors['crimson'],
  'function-scrim': colors['black-opacity30'],
  'function-success': colors['grass'],
  'functional-error': colors['crimson'],
  'functional-success': colors['grass'],
  'functional-focus': colors['tone-maroon-t3'],
  'functional-focus-alt': colors['tone-orange-t3'],
  'graphic-background-accent': colors['neutral-2'],
  'graphic-background-contrast': colors['purple-dark'],
  'graphic-background': colors['white'],
  'graphic-background-default': colors['white'],
  'graphic-background-accent-light': colors['neutral-1'],
  'graphic-divider-light': colors['neutral-2'],
  'graphic-divider': colors['neutral-3'],
  'icon-dark': colors['purple-dark'],
  'icon-light': colors.white,
  'primary-brand-muted': colors['purple-bright-opacity40'],
  'primary-brand': colors['purple-bright'],
  'primary-dark-muted': colors['purple-dark-opacity40'],
  'primary-dark': colors['purple-dark'],
  'primary-mid': colors['purple-mid'],
  'primary-mid-muted': colors['purple-mid-opacity10'],
  'text-body': colors['purple-dark'],
  'text-contrast': colors.white,
  'text-placeholder': colors['neutral-5'],
  'text-title': colors['purple-dark'],
  'link-default': colors['purple-dark'],
  'link-hover': colors['purple-dark'],
  'link-active': colors['purple-dark'],
  'link-visited': colors['tone-blue'],
  'link-disabled': colors['neutral-3'],
  'link-underline-default': colors['purple-bright'],
  'link-underline-hover': colors['purple-mid'],
  'link-underline-active': colors['purple-mid']
};
var legacyColorNameMapping = {
  denim: colors['tone-blue'],
  'grey-alabaster': colors['neutral-1'],
  'grey-aluminium': colors['neutral-3'],
  'grey-slate-opacity40': colors['purple-dark-opacity40'],
  'grey-slate-opacity60': colors['purple-dark-opacity60'],
  'grey-slate-opacity80': colors['purple-dark-opacity80'],
  'grey-slate': colors['purple-dark'],
  'grey-steel-opacity50': colors['neutral-5-opacity50'],
  'grey-steel': colors['neutral-5'],
  'grey-stone': colors['neutral-2'],
  helm: colors['tone-blue-t1'],
  lemon: colors['tone-orange-t2'],
  lychee: colors['tone-maroon-t1'],
  'primary-dark-opacity40': colors['purple-dark-opacity40'],
  'primary-light': colors['purple-dark'],
  'primary-light-opacity10': colors['purple-dark-opacity40'],
  satsuma: colors['tone-brown-t1']
};
var base = {
  name: 'Zoopla',
  colors: _objectSpread(_objectSpread(_objectSpread({}, colors), colorNameMapping), legacyColorNameMapping),
  fontSizes: ['0.75rem', '0.875rem', '1rem', '3rem', '2.5rem', '2rem', '1.75rem', '1.5rem', '1.375rem', '1.125rem'],
  pageWidth: 1200,
  space: ['0.125rem', '0.25rem', '0.5rem', '1rem', '1.5rem', '2rem', '3rem', '4rem', '5rem', '6.5rem'],
  iconSizes: ['0.75rem', '1rem', '1.25rem', '1.5rem', '2rem'],
  bulletSize: {
    large: '0.5rem',
    small: '0.3rem'
  },
  stickyBarHeight: '59px',
  transitionTime: '0.2s',
  transitionDelay: '0.5s',
  letterSpacing: {
    default: '0.2px'
  },
  breakpoints: [480, 768, 960, 1232],
  fontWeight: {
    bold: 'bold',
    semiBold: '600',
    normal: '400',
    '400': '400',
    '600': '600'
  },
  boxShadow: {
    '100': '0px 0px 8px #3227440a,0px 0px 1px #32274452,0px 8px 8px -8px #32274429',
    '200': '0px 0px 12px #32274414,0px 0px 1px #32274452,0px 8px 16px -8px #32274405',
    '800': '0px 0px 12px #32274414,0px 0px 1px #32274452,0px 8px 16px -8px #32274414',
    '900': '0px 0px 24px #3227443d'
  },
  opacity: {
    '100': '80%',
    '200': '30%',
    '300': '10%',
    '400': '4%',
    transparent: '0%'
  }
};
export var zooplaTheme = _objectSpread(_objectSpread({}, base), {}, {
  borderWidth: {
    '100': '1px',
    '200': '2px'
  },
  borderRadius: {
    'border-radius-1': base.space[1],
    'border-radius-2': base.space[2],
    'border-radius-3': base.space[3],
    'border-radius-4': base.space[4],
    'border-radius-5': base.space[5],
    '4px': base.space[1],
    '8px': base.space[2],
    '16px': base.space[3],
    '24px': base.space[4],
    '32px': base.space[5],
    '100': '0px',
    '200': '2px',
    '300': '4px',
    '400': '8px',
    '500': '16px',
    '600': '24px',
    circle: '100%',
    pill: '999px'
  },
  spacing: {
    'micro-spacing-1': base.space[0],
    'micro-spacing-2': base.space[1],
    'spacing-1': base.space[2],
    'spacing-2': base.space[3],
    'spacing-3': base.space[4],
    'spacing-4': base.space[5],
    'spacing-5': base.space[6],
    'spacing-6': base.space[7],
    'spacing-7': base.space[8],
    'spacing-8': base.space[9],
    '2px': base.space[0],
    '4px': base.space[1],
    '8px': base.space[2],
    '16px': base.space[3],
    '24px': base.space[4],
    '32px': base.space[5],
    '48px': base.space[6],
    '64px': base.space[7],
    '80px': base.space[8],
    '104px': base.space[9]
  },
  iconSize: {
    xsmall: base.iconSizes[0],
    small: base.iconSizes[1],
    medium: base.iconSizes[2],
    large: base.iconSizes[3],
    extraLarge: base.iconSizes[4]
  },
  mediaQueries: {
    extraLarge: "@media only screen and (min-width: ".concat(base.breakpoints[3], "px)"),
    large: "@media only screen and (min-width: ".concat(base.breakpoints[2], "px)"),
    medium: "@media only screen and (min-width: ".concat(base.breakpoints[1], "px)"),
    small: "@media only screen and (min-width: ".concat(base.breakpoints[0], "px)")
  },
  zIndex: {
    modal: '1000'
  },
  mq: {
    extraLarge: "@media only screen and (min-width: ".concat(base.breakpoints[3], "px)"),
    large: "@media only screen and (min-width: ".concat(base.breakpoints[2], "px)"),
    medium: "@media only screen and (min-width: ".concat(base.breakpoints[1], "px)"),
    small: "@media only screen and (min-width: ".concat(base.breakpoints[0], "px)")
  },
  link: {
    activeColor: base.colors['primary-brand'],
    color: base.colors['primary-brand'],
    disabledColor: base.colors['neutral-3'],
    hoverColor: base.colors['primary-mid'],
    visitedColor: base.colors['tone-blue']
  },
  buttons: {
    primary: {
      backgroundColor: base.colors['primary-brand'],
      borderColor: base.colors['primary-brand'],
      color: base.colors.white,
      disabledBackgroundColor: base.colors['neutral-2'],
      disabledBorderColor: base.colors['neutral-2'],
      disabledColor: base.colors['neutral-3'],
      hoverBackgroundColor: base.colors['primary-mid'],
      hoverBorderColor: base.colors['primary-mid'],
      hoverColor: base.colors.white
    },
    primaryInverted: {
      backgroundColor: base.colors['white'],
      borderColor: base.colors['white'],
      color: base.colors['primary-dark'],
      disabledBackgroundColor: base.colors['white-opacity10'],
      disabledBorderColor: base.colors['transparent'],
      disabledColor: base.colors['white-opacity30'],
      hoverBackgroundColor: base.colors['white-purple-mid-mix'],
      hoverBorderColor: base.colors['white-purple-mid-mix'],
      hoverColor: base.colors['primary-dark']
    },
    secondary: {
      backgroundColor: base.colors['transparent'],
      borderColor: base.colors['primary-dark'],
      color: base.colors['primary-dark'],
      disabledBackgroundColor: base.colors.white,
      disabledBorderColor: base.colors['primary-dark-muted'],
      disabledColor: base.colors['primary-dark-muted'],
      hoverBackgroundColor: base.colors['primary-dark'],
      hoverBorderColor: base.colors['primary-dark'],
      hoverColor: base.colors.white
    },
    secondaryInverted: {
      backgroundColor: base.colors['transparent'],
      borderColor: base.colors.white,
      color: base.colors.white,
      disabledBackgroundColor: base.colors['transparent'],
      disabledBorderColor: base.colors['white-opacity30'],
      disabledColor: base.colors['white-opacity30'],
      hoverBackgroundColor: base.colors['white-opacity80'],
      hoverBorderColor: base.colors['white-opacity80'],
      hoverColor: base.colors['primary-dark']
    },
    tertiary: {
      backgroundColor: base.colors['transparent'],
      borderColor: base.colors['primary-brand'],
      color: base.colors['primary-dark'],
      disabledBackgroundColor: base.colors['transparent'],
      disabledBorderColor: base.colors['primary-brand-muted'],
      disabledColor: base.colors['primary-dark-muted'],
      hoverBackgroundColor: base.colors['transparent'],
      hoverBorderColor: base.colors['primary-mid'],
      hoverColor: base.colors['purple-dark']
    },
    tertiaryInverted: {
      backgroundColor: base.colors['transparent'],
      borderColor: base.colors['white'],
      color: base.colors['white'],
      disabledBackgroundColor: base.colors['transparent'],
      disabledBorderColor: base.colors['transparent'],
      disabledColor: base.colors['white-opacity30'],
      hoverBackgroundColor: base.colors['transparent'],
      hoverBorderColor: base.colors['white'],
      hoverColor: base.colors['white']
    }
  },
  focusRing: "0 0 0 3px ".concat(base.colors['tone-maroon-t3']),
  type: {
    small: base.fontSizes[0],
    secondary: base.fontSizes[1],
    body: base.fontSizes[2],
    '1': base.fontSizes[3],
    '2': base.fontSizes[4],
    '3': base.fontSizes[5],
    '4': base.fontSizes[6],
    '5': base.fontSizes[7],
    '6': base.fontSizes[8],
    '7': base.fontSizes[9],
    '8': base.fontSizes[2],
    lineHeight: 1.625,
    titleLineHeight: 1.25,
    size8LineHeight: 1.375,
    bold: base.fontWeight.bold,
    semiBold: base.fontWeight.semiBold,
    normal: base.fontWeight.normal
  },
  input: {
    activeBorderColor: base.colors['primary-dark'],
    backgroundColor: base.colors.white,
    borderColor: base.colors['neutral-3'],
    borderColorSearch: base.colors['purple-dark'],
    color: base.colors['primary-dark'],
    disabledBackgroundColor: base.colors.white,
    disabledBorderColor: base.colors['neutral-2'],
    disabledColor: base.colors['neutral-3'],
    hoverBorderColor: base.colors['neutral-4'],
    hoverBackgroundColor: base.colors['neutral-1'],
    invalidBorderColor: base.colors['function-error'],
    labelColor: base.colors['primary-dark'],
    textFieldlabelColor: base.colors['neutral-5'],
    activeLabelColor: base.colors['primary-dark']
  },
  badge: {
    badgeBackgroundJustAdded: base.colors['tone-orange-t2'],
    badgeBackgroundPremium: base.colors['purple-bright'],
    badgeBackgroundSaved: base.colors['graphic-background'],
    badgeBackgroundFeatured: base.colors['tone-blue'],
    badgeColorJustAdded: base.colors['purple-dark'],
    badgeColorPremium: base.colors['text-contrast'],
    badgeColorSaved: base.colors['purple-dark'],
    badgeColorFeatured: base.colors['white'],
    level1: {
      background: colorNameMapping['graphic-background-contrast'],
      border: colorNameMapping['graphic-background-contrast'],
      color: colorNameMapping['text-contrast']
    },
    level2: {
      background: colors['tone-orange-t2'],
      border: colors['tone-orange-t2'],
      color: colorNameMapping['text-body']
    },
    level3: {
      background: colorNameMapping['graphic-background-default'],
      border: colors['tone-orange-t2'],
      color: colorNameMapping['graphic-background-contrast']
    },
    level4: {
      background: colorNameMapping['graphic-background-default'],
      border: colorNameMapping['text-body'],
      color: colorNameMapping['text-body']
    },
    premium: {
      background: colors['purple-bright'],
      border: colors['purple-bright'],
      color: colorNameMapping['text-contrast']
    },
    featured: {
      background: colors['tone-maroon-t3'],
      border: colors['tone-maroon-t3'],
      color: colorNameMapping['text-body']
    },
    saved: {
      background: colorNameMapping['graphic-background-default'],
      border: colorNameMapping['graphic-background-default'],
      color: colorNameMapping['text-body']
    },
    expired: {
      background: colorNameMapping['functional-error'],
      border: colorNameMapping['functional-error'],
      color: colorNameMapping['text-contrast']
    }
  },
  table: {
    'border-default': colors['neutral-2']
  }
});
//# sourceMappingURL=index.js.map